export const ru = {
    date_placeholder: 'дд.мм.гггг',
    trip_does_not_exist: 'Данной командировки не существует',
    value_error: 'Неверное значение поля',
    gender: 'Пол',
    choose_document: 'Выбрать документ',
    add_document: 'Добавить документ',
};
